import type { CSSObject } from 'styled-components'

export const BORDER_RADIUS: CSSObject = {
  borderRadius: 6,
}

export const BORDER_RADIUS_LARGE: CSSObject = {
  borderRadius: 12,
}
